import { t } from "../../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';

import {UploadDocument} from '..';

export const UploadDocuments = ({
  controlUuid,
  setPopUpDisabled,
  uploadedFiles,
  onClose,
  saveAsDraft
}) => {
  const [documentsUploaded, setDocumentsUploaded] = useState([]);
  const [documentsToUpload, setDocumentsToUpload] = useState(uploadedFiles);
  const [uploadingDocumentKey, setUploadingDocumentKey] = useState(null);

  useEffect(() => {
    setUploadingDocumentKey(documentsToUpload[0].key);
    setDocumentsToUpload(prevState => prevState.slice(1));
    setPopUpDisabled(true);
  }, []);

  useEffect(() => {
    if (!documentsToUpload.length) {
      setPopUpDisabled(false);
    }
  }, [documentsToUpload]);

  function handleFinishUpload(uploadedDocumentData=null) {
    if (uploadedDocumentData) {
      // update documentsUploaded list with the new data from backend after adding
      // it's possible that document data is not delivered here,
      // e.g. because of an error
      setDocumentsUploaded(prevVal => [...prevVal, uploadedDocumentData]);
    }
    if (documentsToUpload.length) {
      setUploadingDocumentKey(documentsToUpload[0].key);
      setDocumentsToUpload(prevState => prevState.slice(1));
    } else {
      setUploadingDocumentKey(null);
    }
  }

  function handleFinishUploading() {
    onClose(documentsUploaded);
  }

  return (
    <>
      <span className="sr-only" role="status">{ t('g-list-saved-documents') }</span>
      <ul className="documents__added-files-list">
        {uploadedFiles.map(file_ =>
          <UploadDocument
            controlUuid={controlUuid}
            fileData={file_}
            key={file_.key}
            saveAsDraft={saveAsDraft}
            uploadingDocumentKey={uploadingDocumentKey}
            onFinishUpload={handleFinishUpload}
          />
        )}
      </ul>
      {!documentsToUpload.length && !uploadingDocumentKey &&
          <div className="documents__btn-flex">
            <button className="btn save-btn" type="button" onClick={handleFinishUploading}>
              { t('g-close') }
            </button>
          </div>
      }
    </>
  )
};
